import { BaseBuildPart } from './base-build-part';
import { HelperParams } from './helper-params';
import { ActivityReportsBuildPart } from './activity-reports-build-part';
import { AdminKitInventoryBuildPart } from './admin-kit-inventory-build-part';
import { CoordinatorEQueryBuildPart } from './coordinator-e-query-build-part';
import { AdminEQueryBuildPart } from './admin-e-query-build-part';

export class AdminBuildPart extends BaseBuildPart {
    constructor(private readonly adminHelperParams: HelperParams,
                parent: BaseBuildPart) {
        super(adminHelperParams, parent, ['admin']);
        this.adminHelperParams = adminHelperParams;
    }

    public uploadDocuments(categoryId?: string): BaseBuildPart {
        const paths = ['documents'];

        if (categoryId) {
            paths.push(categoryId);
        }

        return new BaseBuildPart(this.adminHelperParams, this, paths);
    }

    public announcements(): BaseBuildPart {
        return new BaseBuildPart(this.adminHelperParams, this, ['announcements']);
    }

    public commonLinks(): BaseBuildPart {
        return new BaseBuildPart(this.adminHelperParams, this, ['common-links']);
    }

    public protocols(): BaseBuildPart {
        return new BaseBuildPart(this.adminHelperParams, this, ['protocols']);
    }

    public userAccess(): BaseBuildPart {
        return new BaseBuildPart(this.adminHelperParams, this, ['user-profiles']);
    }

    public auditLogs(): BaseBuildPart {
        return new BaseBuildPart(this.adminHelperParams, this, ['audit-logs']);
    }

    public kitInventory(): AdminKitInventoryBuildPart {
        return new AdminKitInventoryBuildPart(this.adminHelperParams, this); 
    }

    public coordinatorEQuery(): CoordinatorEQueryBuildPart {
        return new CoordinatorEQueryBuildPart(this.adminHelperParams, this);
    }

    public adminEQuery(): AdminEQueryBuildPart {
        return new AdminEQueryBuildPart(this.adminHelperParams, this);
    }

    public activityReports(): ActivityReportsBuildPart {
        return new ActivityReportsBuildPart(this.adminHelperParams, this);
    }

    public editDefaultColumns(): BaseBuildPart {
        return new BaseBuildPart(this.adminHelperParams, this, ['edit', 'columns']);
    }
}